import {
  RoleService,
  CreateRoleDto,
  UpdateRoleDto,
  AssignRolesDto,
  MemberRolesBySiteResponseDto,
  MemberRolesResponseDto,
} from '@services/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'

export const findAllRoles = createAsyncThunk(
  Actions.ROLE_FIND_ALL,
  async (_, { rejectWithValue }) => {
    try {
      const roles: any = await RoleService.findAllRoles()
      return roles
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const findOneRole = createAsyncThunk(
  Actions.ROLE_FIND_ONE,
  async (id: number, { rejectWithValue }) => {
    try {
      return await RoleService.findOneRole({ id })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const updateRole = createAsyncThunk(
  Actions.ROLE_UPDATE,
  async (
    { id, body }: { id: number; body: UpdateRoleDto },
    { rejectWithValue },
  ) => {
    try {
      return await RoleService.updateRole({ id, body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const createRole = createAsyncThunk(
  Actions.ROLE_CREATE,
  async (body: CreateRoleDto, { rejectWithValue }) => {
    try {
      return await RoleService.createRole({ body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const deleteRoles = createAsyncThunk(
  Actions.ROLE_REMOVE,
  async ({ ids }: { ids: number[] }, { rejectWithValue }) => {
    try {
      return await RoleService.deleteRole({ ids })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const fetchMemberRoles = createAsyncThunk<
  MemberRolesBySiteResponseDto,
  number
>(
  Actions.ROLE_FETCH_MEMBER_ROLES,
  async (memberId: number, { rejectWithValue }) => {
    try {
      return await RoleService.getMemberRoles({ memberId })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const assignMemberRoles = createAsyncThunk<
  MemberRolesResponseDto,
  { memberId: number; body: AssignRolesDto; onSuccess: () => void }
>(
  Actions.ROLE_ASSIGN_MEMBER_ROLES,
  async (
    {
      memberId,
      body,
      onSuccess,
    }: {
      memberId: number
      body: AssignRolesDto
      onSuccess: () => void
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await RoleService.assignMemberRoles({ memberId, body })
      onSuccess()
      return result
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
